import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './style.css';
import { SharedTable } from '../../modules/common/table';
import NoDataComponent from '../../modules/common/nodataMessage';
import SharedPagination from '../../modules/common/sharedPagination';
import PropertyModal from '../properties/property-modal';
import { setCloseCreateProperty } from '../../redux/features/properties/propertySlice';
import { CreateDevice, FetchDeviceList } from '../../redux/features/device/deviceAction';

const Device = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  const states = useSelector((state: any) => state.deviceSlice);
  const deviceList = states?.deviceList;
  const totalRecord = states?.totalRecord;
  const totalPages = Math.ceil(totalRecord / limit);
  const headers = ["deviceId", "barcode"];

  const handlePageChange = (page) => {
    setCurrentPage(page);
    dispatch(FetchDeviceList({ page, limit }));
  };

  const renderActions = (row: any) => (
    <>
      {/* <span
        onClick={() => deleteProperty(row._id)}
        className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
      >
        <KTIcon iconName="trash" className="fs-3" />
      </span> */}
    </>
  );

  const deleteProperty = (id: string) => {
    // dispatch(DeleteProperty(id));
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          navigate('/auth');
          return;
        }

        const response = await dispatch(FetchDeviceList({ page: currentPage, limit }));
        if (response?.payload?.data?.users) {
          setUsers(response.payload.data.users);
        }
      } catch (error) {
        console.error("Failed to fetch users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [dispatch, navigate]);

  const handleAddDevice = () => {
    console.log("Opening Modal");
    setShowPopup(true);
  };

  const handleConfirmAdd = () => {
    console.log("Device added");
    dispatch(CreateDevice());
    setShowPopup(false);
  };

  const handleCancel = () => {
    setShowPopup(false);
  };

  return (
    <>
      <div>
        <div className='addDeviceTitle'>
          <h3>Elenco dispositivi</h3>
          <button
            className='addDeviceBtn'
            onClick={handleAddDevice}
          >
            Aggiungi nuovo dispositivo
          </button>
        </div>

        {/* Modal for adding a new device */}
        {showPopup && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
            onClick={handleCancel}
          >
            <div
              style={{
                background: 'white',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                minWidth: '300px',
                textAlign: 'center'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <p style={{ fontSize: '16px', margin: '20px 5px' }}>Sei sicuro di voler aggiungere un nuovo dispositivo?</p>
              <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between' }}>
                <button
                  style={{ background: '#28a745', color: 'white', padding: '8px 12px', border: 'none', borderRadius: '5px' }}
                  onClick={handleConfirmAdd}
                >
                  Aggiungi
                </button>
                <button
                  style={{ background: '#dc3545', color: 'white', padding: '8px 12px', border: 'none', borderRadius: '5px' }}
                  onClick={handleCancel}
                >
                  Annulla
                </button>
              </div>
            </div>
          </div>
        )}

        <div className='deviceListTable'>
          {loading ? (
            <p>Caricamento in corso...</p>
          ) : deviceList?.length > 0 ? (
            <SharedTable
              headers={headers}
              data={deviceList}
              renderActions={renderActions}
              // renderActions={null}
              getDetail={null}
            />
          ) : (
            <NoDataComponent
              message="Nessun dispositivo trovato. Creane uno per iniziare!"
              showButton={false}
              buttonText=""
              onButtonClick={null}
            />
          )}
        </div>

        {totalRecord > 10 && <SharedPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />}

        {states?.openPropertyModal && (
          <PropertyModal
            show={states?.openPropertyModal}
            handleClose={() => dispatch(setCloseCreateProperty())}
          />
        )}

      </div>
    </>
  );
};

export default Device;
